import { useQuery } from "@tanstack/react-query";
import { apiClient } from "~/services/api.service";
import {  endpointsPublic } from "~/services/endpoint";

export const useBlogList = (
  {
    page,
    pageSize,
    name,
  }: {
    page?: number;
    pageSize?: number;
    name?: string;
  } = {}
) => {
  const rawParams = {
    populate: 'image',
    'pagination[page]': page,
    'pagination[pageSize]': pageSize,
    'filters[title][$containsi]': name,
  }
  const params = Object.fromEntries(
    Object.entries(rawParams).filter(([_, v]) => v !== undefined && v !== "")
  );
  const { data, isLoading, refetch } = useQuery({
    queryKey: [endpointsPublic.list_blog, params],
    queryFn: () => {
      return apiClient.get(
        endpointsPublic.list_blog, params
      );
    },
 
  });

  return {
    data,
    isLoading,
    refetch,
  };
};
